/* eslint-disable no-undef */
import data from "../data/demo";

export default function scheduleDemo() {
  if (Calendly) {
    Calendly.initPopupWidget({ url: data.calendlyUrl });
  }
}
